<ems-confirm-message #confirmationMessage></ems-confirm-message>

<div class="heading">
  <span class="select-attributes">Assign Rule</span>
  <tr-rule-name-type *ngIf="assignFormData" [ruleName]="assignFormData.name"
                     [ruleType]="assignFormData.rulesCategory" [isSuperRestriction]="assignFormData.isSuperRestriction === 'Y'"></tr-rule-name-type>
</div>

<div class="step-border-box sdps-p-around_large">
  <p-tabs [value]="activeIndex" *ngIf="!(assignFormData.globalRule && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid,'',''))" class="emtr-tab"
             [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageRule.uuid, '', '')}" [selectOnFocus]="true" [lazy]="true" (onChange)="onChangeTab($event)">
    <p-tablist>
      <p-tab [value]="0" [disabled]="shouldDisabledGroupsOrPlans">{{sharedConstant[businessUnit? businessUnit: 'RBS'].employeeGrpOrPlan}} </p-tab>
      <p-tab [value]="1" [disabled]="shouldDisabledEmployeesOrParticipants">{{sharedConstant[businessUnit? businessUnit: 'RBS'].employeeOrParticipant}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
      <ems-shared-manage-employee-group [showSelection]="true" [empGrpformData]="assignFormData.employeeGroups"
        (initialCount)='getInitialCount($event)' [moduleType]="selectedModuleType" (rowSelected)="employeeRowSelected(true)"
        (employeeGroups)="getDataEmpGrp($event)" [tableCountData]="tableCountData" [employees]="employees"
        (paginateEmployeeList)="paginateEmployeeList($event)"></ems-shared-manage-employee-group>
      </p-tabpanel>
    <p-tabpanel [value]="1">
      <ems-shared-manage-employee-accounts [assignFormData]='assignFormData' [getOrgId]='assignFormData.orgId'
        [moduleType]='loadedModuleType' [empAccformData]="assignFormData.employeeAccounts" [editGroupData]='assignFormData'
        (rowSelected)="employeeRowSelected(true)"
        (selectedEmployeeAccounts)="updateSelectedArray($event)"></ems-shared-manage-employee-accounts>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
  <p-tabs [value]="activeIndex"
    *ngIf="assignFormData.globalRule && sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid,'','')"
    class="emtr-tab"
    [ngClass]="{'sdps-hide': !sharedService.checkEntitlements(entitlementConst.navUUID.emtrAccess.manageRule.uuid, '', '')}"
    [selectOnFocus]="true" [lazy]="true" (onChange)="onChangeTab($event)">
    <!-- Master Group Section -->
    <p-tablist>
      <p-tab [value]="0" [disabled]="shouldDisabledMasterGroups">{{emtrConst.ruleSteps.step3.masterGrpTab}}</p-tab>
      <p-tab [value]="1" [disabled]="shouldDisabledMasterAccounts ||this.entitlementCheck()">{{emtrConst.ruleSteps.step3.clientsTab}}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        <ems-shared-master-groups [showMGPSelection]="true" [mstrGrpformData]="employeeGroups"
          [showActionBtn]="showActionBtn" [masterAcctList]="employees"
          (paginateMasterGrpList)="paginateEmployeeList($event)" (employeeGroups)="updatedMasterGrpData($event)"
          (rowSelected)="employeeRowSelected(true)" (selectedMasterGrp)="masterGrpData($event)"
          [tableCountData]="tableCountData">
        </ems-shared-master-groups>
      </p-tabpanel>
      <!-- Master Accounts Section -->
      <p-tabpanel [value]="1">
        <tr-client-selection-table (rowSelected)="employeeRowSelected(true)"
          (selectedMasterAccounts)="updatedMasterAcc($event)" (unAssignSelectedMstrAccts)="unAssignMstrAccts = $event" [masterGroupMode] = "actionValForGlobalRule"
          (selectedClients)="getSelectedClientData($event)"></tr-client-selection-table>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<ems-step-wizard-buttons [disableBtn]="(this.saveAndContinueButtons() && !isRuleExpired)?'':true"
                         [disablePrevBtn]="isRuleExpired" (goToPrevious)="goToPreviousStep();"
                         [showCancelBtn]="true" [showSaveContinueBtn]="true" [showPreviousBtn]="true"
                         (closeBtn)="cancelCreateRule()" (goToNext)="confirmationPopup()"></ems-step-wizard-buttons>
